import React from 'react';
import { useStore } from '../store';
import { ToggleLeft as Toggle } from 'lucide-react';

export const RouteTogglePanel: React.FC = () => {
  const { routes, activeRoutes, toggleRouteActive, setAllRoutesActive, users } = useStore();
  const [selectedUserId, setSelectedUserId] = React.useState<string | null>(null);

  React.useEffect(() => {
    if (users.length > 0 && !selectedUserId) {
      setSelectedUserId(users[0].id);
    }
  }, [users, selectedUserId]);

  const sortedRoutes = [...routes].sort((a, b) => {
    const aNum = parseInt(a.name.replace(/[^0-9]/g, '')) || 0;
    const bNum = parseInt(b.name.replace(/[^0-9]/g, '')) || 0;
    return aNum - bNum;
  });

  if (!selectedUserId) return null;

  const userActiveRoutes = activeRoutes.get(selectedUserId) || new Set();

  return (
    <div className="absolute right-4 top-32 bg-white p-4 rounded-lg shadow-lg">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold">コース管理</h3>
        <div className="flex items-center gap-2">
          <select
            value={selectedUserId}
            onChange={(e) => setSelectedUserId(e.target.value)}
            className="px-2 py-1 text-sm border rounded"
          >
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}
              </option>
            ))}
          </select>
          <button
            onClick={() => setAllRoutesActive(selectedUserId, true)}
            className="px-2 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            全て有効
          </button>
        </div>
      </div>
      <div className="space-y-2">
        {sortedRoutes.map((route) => {
          const isActive = userActiveRoutes.has(route.id);
          const user = users.find(u => u.id === selectedUserId);
          const isCompleted = user?.completedRoutes?.includes(route.id);

          return (
            <div
              key={route.id}
              className="flex items-center justify-between p-2 rounded hover:bg-gray-50"
            >
              <div className="flex items-center gap-2">
                <div
                  className="w-4 h-4 rounded-full"
                  style={{ backgroundColor: isActive ? (isCompleted ? '#9CA3AF' : route.color) : '#9CA3AF' }}
                />
                <span className={isActive ? 'font-medium' : 'text-gray-500'}>
                  {route.name}
                  {isCompleted && (
                    <span className="ml-2 text-xs text-gray-500">
                      (完了)
                    </span>
                  )}
                </span>
              </div>
              <button
                onClick={() => toggleRouteActive(selectedUserId, route.id)}
                className={`p-1 rounded-full transition-colors ${
                  isActive ? 'text-blue-500 hover:text-blue-600' : 'text-gray-400 hover:text-gray-500'
                }`}
                title={isActive ? 'コースを無効化' : 'コースを有効化'}
              >
                <Toggle className={`w-6 h-6 transform ${isActive ? '' : 'rotate-180'}`} />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};